import { t as i } from "./index861.mjs";
import { i as o } from "./index862.mjs";
var m = i, a = o, v = function(t) {
  var r = m(t, "string");
  return a(r) ? r : r + "";
};
export {
  v as t
};
